/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import ActionConstants from '../constants';
import { getCancelableRequestMeta } from './cancelableRequest';
import {
  getActiveWebhookEventsApi,
  getMerchentSettingsApi,
  updateMerchentGeneralSettingsApi,
  updateMerchentWebhookApi,
  getActiveUsersApi,
  getAllRolesApi,
  getAllPermissionsApi,
  createNewUserApi,
  createNewRoleApi,
  updateUserDetailsApi,
  deleteUserApi,
  resendInvitationApi,
  getCheckoutThemeApi,
  updateCheckoutThemeApi,
  updateMerchantTPV,
  getTicketList,
  caseManagementAuthApi,
  getCategoriesList,
  getSubCategoriesList,
  createTicket,
  uploadDocumentsApi,
  linkDocumentsApi,
  fetchAllCommentsApi,
  addCommentsApi,
  getTicketDetail,
  getAllAttachementsApi,
  attachmentPreviewApi,
  fetchOffersRuleApi,
  setOfferRulesApi,
  getActiveEdgeWebhookEventsApi,
  updateEdgeWebhookEventsApi,
  getV3MerchantWebhookApi,
  updateV3MerchantWebhookApi,
  getActiveEdgePaymentLinksWebhookEventsApi,
  updateEdgePaymentLinksWebhooksApi,
  getEdgeCheckoutThemeApi,
  updateEdgeCheckoutThemeApi,
  updateUnifiedMerchantVersionApi,
  getCheckoutVersionApi,
  getCsrApplePayApi,
  getApplePayWalletStatusApi,
  getApplePayIntegrationStatusApi,
  webRegistrationApplePayApi,
  activateApplePayCertificatesApi,
  getDashboardThemeApi,
  updateDashboardThemeApi,
  getPaymentModesApi,
} from '../../api/settings';
import { getHasMerchantTransactedApi } from '../../api/overview';
import { MerchantIdType, FeatureIdWithMID } from 'lib/typing';
import { updateMerchantVersionPayloadType } from 'screens/Home/UnifiedMerchantVersionUpdate/typing';

type LoaderOptions = {
  hideLoader?: boolean;
  loaderMessage?: string;
};

export const getActiveWebhookEventsAction = (data) => {
  const payload = {
    serviceMethod: getActiveWebhookEventsApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS_FAILURE,
    actionTypeRequest: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS_REQUEST,
  };
  return { type: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS, payload };
};

export const clearActiveWebhookEvents = () => {
  return { type: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS_CLEAR };
};

export const getMerchentSettingsAction = (data) => {
  const payload = {
    serviceMethod: getMerchentSettingsApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_MERCHENT_SETTINGS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_MERCHENT_SETTINGS_FAILURE,
    actionTypeRequest: ActionConstants.GET_MERCHENT_SETTINGS_REQUEST,
  };
  return { type: ActionConstants.GET_MERCHENT_SETTINGS, payload };
};

export const clearMerchentSettingsAction = () => {
  return { type: ActionConstants.GET_MERCHENT_SETTINGS_CLEAR };
};

export const updateMerchentGeneralSettingsAction = (data) => {
  const payload = {
    serviceMethod: updateMerchentGeneralSettingsApi.bind(null, data),
    actionTypeSuccess: ActionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS_SUCCESS,
    actionTypeFailure: ActionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS_FAILURE,
    actionTypeRequest: ActionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS_REQUEST,
  };
  return { type: ActionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS, payload };
};

export const clearUpdateGeneralSettingsAction = () => {
  return { type: ActionConstants.UPDATE_MERCHENT_GENERAL_SETTINGS_CLEAR };
};

export const updateMerchentWebhookAction = (data) => {
  const payload = {
    serviceMethod: updateMerchentWebhookApi.bind(null, data),
    actionTypeSuccess: ActionConstants.UPDATE_MERCHENT_WEBHOOK_SUCCESS,
    actionTypeFailure: ActionConstants.UPDATE_MERCHENT_WEBHOOK_FAILURE,
    actionTypeRequest: ActionConstants.UPDATE_MERCHENT_WEBHOOK_REQUEST,
  };
  return { type: ActionConstants.UPDATE_MERCHENT_WEBHOOK, payload };
};

export const clearUpdateMerchentWebhookAction = () => {
  return { type: ActionConstants.UPDATE_MERCHENT_WEBHOOK_CLEAR };
};

// User Management Actions
export const getActiveUsersAction = (data, options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(data || {}), ...(options || {}) },
      ActionConstants.GET_ACTIVE_USERS_LIST
    );
  const payload = {
    serviceMethod: getActiveUsersApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_ACTIVE_USERS_LIST_SUCCESS,
    actionTypeFailure: ActionConstants.GET_ACTIVE_USERS_LIST_FAILURE,
    actionTypeRequest: ActionConstants.GET_ACTIVE_USERS_LIST_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_ACTIVE_USERS_LIST, payload };
};

export const clearActiveUsersAction = () => {
  return { type: ActionConstants.GET_ACTIVE_USERS_LIST_CLEAR };
};

export const getAllRolesAction = (data, options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(data || {}), ...(options || {}) },
      ActionConstants.GET_ALL_ROLES
    );
  const payload = {
    serviceMethod: getAllRolesApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_ALL_ROLES_SUCCESS,
    actionTypeFailure: ActionConstants.GET_ALL_ROLES_FAILURE,
    actionTypeRequest: ActionConstants.GET_ALL_ROLES_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_ALL_ROLES, payload };
};

export const clearAllRolesAction = () => {
  return { type: ActionConstants.GET_ALL_ROLES_CLEAR };
};

export const getAllPermissionsAction = (data, options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(data || {}), ...(options || {}) },
      ActionConstants.GET_ALL_PERMISSIONS_LIST
    );
  const payload = {
    serviceMethod: getAllPermissionsApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_ALL_PERMISSIONS_LIST_SUCCESS,
    actionTypeFailure: ActionConstants.GET_ALL_PERMISSIONS_LIST_FAILURE,
    actionTypeRequest: ActionConstants.GET_ALL_PERMISSIONS_LIST_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_ALL_PERMISSIONS_LIST, payload };
};

export const clearAllPermissionsAction = () => {
  return { type: ActionConstants.GET_ALL_PERMISSIONS_LIST_CLEAR };
};

export const createNewUserAction = (data) => {
  const payload = {
    serviceMethod: createNewUserApi.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_CREATE_NEW_USER_SUCCESS,
    actionTypeFailure: ActionConstants.POST_CREATE_NEW_USER_FAILURE,
    actionTypeRequest: ActionConstants.POST_CREATE_NEW_USER_REQUEST,
    extra: {
      assignedRoleId: data?.role_id ?? '',
    },
  };
  return { type: ActionConstants.POST_CREATE_NEW_USER, payload };
};

export const clearCreateNewUserStateAction = () => {
  return { type: ActionConstants.POST_CREATE_NEW_USER_CLEAR };
};

export const updateUserDetailsAction = (data) => {
  const payload = {
    serviceMethod: updateUserDetailsApi.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_UPDATE_USER_DETAILS_SUCCESS,
    actionTypeFailure: ActionConstants.POST_UPDATE_USER_DETAILS_FAILURE,
    actionTypeRequest: ActionConstants.POST_UPDATE_USER_DETAILS_REQUEST,
    ...(data?.isShowGuidedTourUpdated && {extra: {
      isShowGuidedTourUpdated : true,
    }})
  };
  return { type: ActionConstants.POST_UPDATE_USER_DETAILS, payload };
};

export const clearUpdateUserStateAction = () => {
  return { type: ActionConstants.POST_UPDATE_USER_DETAILS_CLEAR };
};

export const deleteUserAction = (data) => {
  const payload = {
    serviceMethod: deleteUserApi.bind(null, data),
    actionTypeSuccess: ActionConstants.DELETE_USER_SUCCESS,
    actionTypeFailure: ActionConstants.DELETE_USER_FAILURE,
    actionTypeRequest: ActionConstants.DELETE_USER_REQUEST,
  };
  return { type: ActionConstants.DELETE_USER, payload };
};

export const clearDeleteUserAction = () => {
  return { type: ActionConstants.DELETE_USER_CLEAR };
};

export const createNewRoleAction = (data) => {
  const payload = {
    serviceMethod: createNewRoleApi.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_CREATE_NEW_ROLE_SUCCESS,
    actionTypeFailure: ActionConstants.POST_CREATE_NEW_ROLE_FAILURE,
    actionTypeRequest: ActionConstants.POST_CREATE_NEW_ROLE_REQUEST,
  };
  return { type: ActionConstants.POST_CREATE_NEW_ROLE, payload };
};

export const clearCreateNewRoleStateAction = () => {
  return { type: ActionConstants.POST_CREATE_NEW_ROLE_CLEAR };
};

export const resendInvitationAction = (data) => {
  const payload = {
    serviceMethod: resendInvitationApi.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_RESEND_INVITATION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_RESEND_INVITATION_FAILURE,
    actionTypeRequest: ActionConstants.POST_RESEND_INVITATION_REQUEST,
  };
  return { type: ActionConstants.POST_RESEND_INVITATION, payload };
};

export const clearResendInvitationAction = () => {
  return { type: ActionConstants.POST_RESEND_INVITATION_CLEAR };
};

// Checkout Theme Actions
export const getCheckoutThemeAction = (data, options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(data || {}), ...(options || {}) },
      ActionConstants.GET_CHECKOUT_THEME
    );
  const payload = {
    serviceMethod: getCheckoutThemeApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_CHECKOUT_THEME_SUCCESS,
    actionTypeFailure: ActionConstants.GET_CHECKOUT_THEME_FAILURE,
    actionTypeRequest: ActionConstants.GET_CHECKOUT_THEME_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_CHECKOUT_THEME, payload };
};

export const getEdgeCheckoutThemeAction = (options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(options || {}) },
      ActionConstants.GET_CHECKOUT_THEME
    );
  const payload = {
    serviceMethod: getEdgeCheckoutThemeApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_CHECKOUT_THEME_SUCCESS,
    actionTypeFailure: ActionConstants.GET_CHECKOUT_THEME_FAILURE,
    actionTypeRequest: ActionConstants.GET_CHECKOUT_THEME_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_CHECKOUT_THEME, payload };
};


export const clearGetCheckoutThemeAction = () => {
  return { type: ActionConstants.GET_CHECKOUT_THEME_CLEAR };
};

export const updateCheckoutThemeAction = (data) => {
  const payload = {
    serviceMethod: updateCheckoutThemeApi.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_UPDATE_CHECKOUT_THEME_SUCCESS,
    actionTypeFailure: ActionConstants.POST_UPDATE_CHECKOUT_THEME_FAILURE,
    actionTypeRequest: ActionConstants.POST_UPDATE_CHECKOUT_THEME_REQUEST,
  };
  return { type: ActionConstants.POST_UPDATE_CHECKOUT_THEME, payload };
};

export const updateEdgeCheckoutThemeAction = (data) => {
  const payload = {
    serviceMethod: updateEdgeCheckoutThemeApi.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_UPDATE_CHECKOUT_THEME_SUCCESS,
    actionTypeFailure: ActionConstants.POST_UPDATE_CHECKOUT_THEME_FAILURE,
    actionTypeRequest: ActionConstants.POST_UPDATE_CHECKOUT_THEME_REQUEST,
  };
  return { type: ActionConstants.POST_UPDATE_CHECKOUT_THEME, payload };
};

export const clearUpdateCheckoutThemeAction = () => {
  return { type: ActionConstants.POST_UPDATE_CHECKOUT_THEME_CLEAR };
};

export const updateMerchantTPVAction = (data: {
  enable_tpv: boolean;
  merchant_id: MerchantIdType;
}) => {
  const payload = {
    serviceMethod: updateMerchantTPV.bind(null, data),
    actionTypeSuccess: ActionConstants.PUT_UPDATE_MERCHANT_TPV_SUCCESS,
    actionTypeFailure: ActionConstants.PUT_UPDATE_MERCHANT_TPV_FAILURE,
    actionTypeRequest: ActionConstants.PUT_UPDATE_MERCHANT_TPV_REQUEST,
    extra: { enable_tpv: data.enable_tpv },
  };
  return {
    type: ActionConstants.PUT_UPDATE_MERCHANT_TPV_ACTION,
    payload,
  };
};

export const clearUpdateMerchantTPVAction = () => {
  return { type: ActionConstants.PUT_UPDATE_MERCHANT_TPV_CLEAR };
};

export const getCaseManagementAuth = (data) => {
  const payload = {
    serviceMethod: caseManagementAuthApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_CASE_MANAGEMENT_AUTH_SUCCESS,
    actionTypeFailure: ActionConstants.GET_CASE_MANAGEMENT_AUTH_FAILURE,
    actionTypeRequest: ActionConstants.GET_CASE_MANAGEMENT_AUTH_REQUEST,
  };
  return {
    type: ActionConstants.GET_CASE_MANAGEMENT_AUTH_ACTION,
    payload,
  };
};

export const getAllTicketsForMerchant = (data:any, authParams:any) => {
  const payload = {
    serviceMethod: getTicketList.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_TICKET_LIST_SUCCESS,
    actionTypeFailure: ActionConstants.GET_TICKET_LIST_FAILURE,
    actionTypeRequest: ActionConstants.GET_TICKET_LIST_REQUEST,
  };
  return {
    type: ActionConstants.GET_TICKET_LIST_ACTION,
    payload,
  };
};

export const getTicketDetailAction = (data:any, authParams:any) => {
  const payload = {
    serviceMethod: getTicketDetail.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_TICKET_DETAIL_SUCCESS,
    actionTypeFailure: ActionConstants.GET_TICKET_DETAIL_FAILURE,
    actionTypeRequest: ActionConstants.GET_TICKET_DETAIL_REQUEST,
  };
  return {
    type: ActionConstants.GET_TICKET_DETAIL_ACTION,
    payload,
  };
};

export const getAllCategories = (authParams:any) => {
  const payload = {
    serviceMethod: getCategoriesList.bind(null, authParams),
    actionTypeSuccess: ActionConstants.GET_CATEGORY_SUCCESS,
    actionTypeFailure: ActionConstants.GET_CATEGORY_FAILURE,
    actionTypeRequest: ActionConstants.GET_CATEGORY_REQUEST,
    hideLoader: true,
  };
  return {
    type: ActionConstants.GET_CATEGORY_ACTION,
    payload,
  };
};

export const getAllSubCategories = (data:any, authParams:any) => {
  const payload = {
    serviceMethod: getSubCategoriesList.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_SUBCATEGORY_SUCCESS,
    actionTypeFailure: ActionConstants.GET_SUBCATEGORY_FAILURE,
    actionTypeRequest: ActionConstants.GET_SUBCATEGORY_REQUEST,
    hideLoader: true,
  };
  return {
    type: ActionConstants.GET_SUBCATEGORY_ACTION,
    payload,
  };
};

export const createNewTicket = (data:any, authParams:any) => {
  const payload = {
    serviceMethod: createTicket.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_CREATE_TICKET_SUCCESS,
    actionTypeFailure: ActionConstants.GET_CREATE_TICKET_FAILURE,
    actionTypeRequest: ActionConstants.GET_CREATE_TICKET_REQUEST,
  };
  return {
    type: ActionConstants.GET_CREATE_TICKET_ACTION,
    payload,
  };
};

export const clearTicket = () => {
  return {
    type: ActionConstants.GET_CREATE_TICKET_CLEAR,
  };
};

export const uploadDocuments = (data:any, authParams:any) => {
  const payload = {
    serviceMethod: uploadDocumentsApi.bind(null, data, authParams),
    actionTypeSuccess: ActionConstants.GET_UPLOAD_DOCUMENTS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_UPLOAD_DOCUMENTS_FAILURE,
    actionTypeRequest: ActionConstants.GET_UPLOAD_DOCUMENTS_REQUEST,
  };
  return {
    type: ActionConstants.GET_UPLOAD_DOCUMENTS_ACTION,
    payload,
  };
};

export const linkDocumentsToTicket = (ticketId:string, data:any, authParams:any) => {
  const payload = {
    serviceMethod: linkDocumentsApi.bind(null, ticketId, data, authParams),
    actionTypeSuccess: ActionConstants.GET_LINK_DOCUMENTS_TO_TICKETS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_LINK_DOCUMENTS_TO_TICKETS_FAILURE,
    actionTypeRequest: ActionConstants.GET_LINK_DOCUMENTS_TO_TICKETS_REQUEST,
  };
  return {
    type: ActionConstants.GET_LINK_DOCUMENTS_TO_TICKETS_ACTION,
    payload,
  };
};

export const fetchAllCommentsAction = (ticketId:string, authParams:any) => {
  const payload = {
    serviceMethod: fetchAllCommentsApi.bind(null, ticketId, authParams),
    actionTypeSuccess: ActionConstants.GET_ALL_COMMENTS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_ALL_COMMENTS_FAILURE,
    actionTypeRequest: ActionConstants.GET_ALL_COMMENTS_REQUEST,
    hideLoader: true,
  };
  return {
    type: ActionConstants.GET_ALL_COMMENTS_ACTION,
    payload,
  };
};

export const addCommentsAction = (ticketId:string, data:any, authParams:any) => {
  const payload = {
    serviceMethod: addCommentsApi.bind(null, ticketId, data, authParams),
    actionTypeSuccess: ActionConstants.ADD_COMMENTS_SUCCESS,
    actionTypeFailure: ActionConstants.ADD_COMMENTS_FAILURE,
    actionTypeRequest: ActionConstants.ADD_COMMENTS_REQUEST,
  };
  return {
    type: ActionConstants.ADD_COMMENTS_ACTION,
    payload,
  };
};

export const getAllAttachementsAction = (ticketId:string, authParams:any) => {
  const payload = {
    serviceMethod: getAllAttachementsApi.bind(null, ticketId, authParams),
    actionTypeSuccess: ActionConstants.GET_ALL_ATTACHMENTS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_ALL_ATTACHMENTS_FAILURE,
    actionTypeRequest: ActionConstants.GET_ALL_ATTACHMENTS_REQUEST,
    hideLoader: true,
  };
  return {
    type: ActionConstants.GET_ALL_ATTACHMENTS_ACTION,
    payload,
  };
};

export const attachmentPreviewAction = (ticketId:string, documentId: string, authParams:any) => {
  const payload = {
    serviceMethod: attachmentPreviewApi.bind(null, ticketId, documentId, authParams),
    actionTypeSuccess: ActionConstants.GET_PREVIEW_SUCCESS,
    actionTypeFailure: ActionConstants.GET_PREVIEW_FAILURE,
    actionTypeRequest: ActionConstants.GET_PREVIEW_REQUEST,
  };
  return {
    type: ActionConstants.GET_PREVIEW_ACTION,
    payload,
  };
};

export const fetchOfferRulesAction = (merchantId: MerchantIdType) => {
  const payload = {
    serviceMethod: fetchOffersRuleApi.bind(null, merchantId),
    actionTypeSuccess: ActionConstants.FETCH_OFFERS_RULE_SUCCESS,
    actionTypeFailure: ActionConstants.FETCH_OFFERS_RULE_FAILURE,
    actionTypeRequest: ActionConstants.FETCH_OFFERS_RULE_REQUEST,
  };
  return { type: ActionConstants.FETCH_OFFERS_RULE, payload };
};

export const clearFetchOfferRulesAction = () => {
  return { type: ActionConstants.FETCH_OFFERS_RULE_CLEAR };
};

export const setOfferRulesAction = (data: FeatureIdWithMID) => {
  const payload = {
    serviceMethod: setOfferRulesApi.bind(null, data),
    actionTypeSuccess: ActionConstants.SET_OFFERS_RULE_SUCCESS,
    actionTypeFailure: ActionConstants.SET_OFFERS_RULE_FAILURE,
    actionTypeRequest: ActionConstants.SET_OFFERS_RULE_REQUEST,
  };
  return { type: ActionConstants.SET_OFFERS_RULE, payload };
};

export const clearSetOfferRulesAction = () => {
  return { type: ActionConstants.SET_OFFERS_RULE_CLEAR };
};

export const getActiveEdgeWebhookEventsAction = (options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(options || {}) },
      ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS
    );
  const payload = {
    serviceMethod: getActiveEdgeWebhookEventsApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS_FAILURE,
    actionTypeRequest: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_ACTIVE_WEBHOOK_EVENTS, payload };
};

export const updateEdgeWebhookEventsAction = (data) => {
  const payload = {
    serviceMethod: updateEdgeWebhookEventsApi.bind(null, data),
    actionTypeSuccess: ActionConstants.UPDATE_MERCHENT_WEBHOOK_SUCCESS,
    actionTypeFailure: ActionConstants.UPDATE_MERCHENT_WEBHOOK_FAILURE,
    actionTypeRequest: ActionConstants.UPDATE_MERCHENT_WEBHOOK_REQUEST,
  };
  return { type: ActionConstants.UPDATE_MERCHENT_WEBHOOK, payload };
};

export const getV3MerchantWebhookAction = (data, options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(data || {}), ...(options || {}) },
      ActionConstants.GET_V3_MERCHANT_WEBHOOK
    );
  const payload = {
    serviceMethod: getV3MerchantWebhookApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_V3_MERCHANT_WEBHOOK_SUCCESS,
    actionTypeFailure: ActionConstants.GET_V3_MERCHANT_WEBHOOK_FAILURE,
    actionTypeRequest: ActionConstants.GET_V3_MERCHANT_WEBHOOK_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_V3_MERCHANT_WEBHOOK, payload };
};

export const clearV3MerchantWebhookAction = () => {
  return { type: ActionConstants.GET_V3_MERCHANT_WEBHOOK_CLEAR };
};

export const updateV3MerchantWebhookAction = (data) => {
  const payload = {
    serviceMethod: updateV3MerchantWebhookApi.bind(null, data),
    actionTypeSuccess: ActionConstants.UPDATE_V3_MERCHANT_WEBHOOK_SUCCESS,
    actionTypeFailure: ActionConstants.UPDATE_V3_MERCHANT_WEBHOOK_FAILURE,
    actionTypeRequest: ActionConstants.UPDATE_V3_MERCHANT_WEBHOOK_REQUEST,
  };
  return { type: ActionConstants.UPDATE_V3_MERCHANT_WEBHOOK, payload };
};

export const clearUpdateV3MerchantWebhookAction = () => {
  return { type: ActionConstants.UPDATE_V3_MERCHANT_WEBHOOK_CLEAR };
};

export const getActiveEdgePaymentLinksWebhookEventsAction = (
  options?: LoaderOptions
) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(options || {}) },
      ActionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS
    );
  const payload = {
    serviceMethod: getActiveEdgePaymentLinksWebhookEventsApi.bind(
      null,
      requestData
    ),
    actionTypeSuccess:
      ActionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_SUCCESS,
    actionTypeFailure:
      ActionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_FAILURE,
    actionTypeRequest:
      ActionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return {
    type: ActionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS,
    payload,
  };
};

export const clearActiveEdgePaymentLinksWebhookEventsAction = () => {
  return {
    type: ActionConstants.GET_ACTIVE_EDGE_PAYMENTS_LINKS_WEBHOOK_EVENTS_CLEAR,
  };
};

export const updateEdgePaymentLinksWebhookAction = (data) => {
  const payload = {
    serviceMethod: updateEdgePaymentLinksWebhooksApi.bind(null, data),
    actionTypeSuccess:
      ActionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_SUCCESS,
    actionTypeFailure:
      ActionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_FAILURE,
    actionTypeRequest:
      ActionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_REQUEST,
  };
  return { type: ActionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK, payload };
};

export const clearUpdateEdgePaymentLinksWebhookAction = () => {
  return { type: ActionConstants.UPDATE_EDGE_PAYMENT_LINKS_WEBHOOK_CLEAR };
};

export const updateMerchantVersionAction = (data: updateMerchantVersionPayloadType) => {
  const { cancelKey, requestId, requestData } = getCancelableRequestMeta(
    data,
    ActionConstants.POST_UPDATE_MERCHANT_VERSION,
    false
  );
  const payload = {
    serviceMethod: updateUnifiedMerchantVersionApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.POST_UPDATE_MERCHANT_VERSION_SUCCESS,
    actionTypeFailure: ActionConstants.POST_UPDATE_MERCHANT_VERSION_FAILURE,
    actionTypeRequest: ActionConstants.POST_UPDATE_MERCHANT_VERSION_REQUEST,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.POST_UPDATE_MERCHANT_VERSION, payload };
};

export const clearUpdateMerchantVersionAction = () => {
  return { type: ActionConstants.POST_UPDATE_MERCHANT_VERSION_CLEAR };
};


export const getCheckoutVersionAction = (options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(options || {}) },
      ActionConstants.GET_CHECKOUT_VERSION
    );
  const payload = {
    serviceMethod: getCheckoutVersionApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_CHECKOUT_VERSION_SUCCESS,
    actionTypeFailure: ActionConstants.GET_CHECKOUT_VERSION_FAILURE,
    actionTypeRequest: ActionConstants.GET_CHECKOUT_VERSION_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_CHECKOUT_VERSION, payload };
};

export const clearGetCheckoutVersionAction = () => {
  return { type: ActionConstants.GET_CHECKOUT_VERSION_CLEAR };
};

export const getHasMerchantTransactedAction = () => {
  const payload = {
    serviceMethod: getHasMerchantTransactedApi,
    actionTypeSuccess: ActionConstants.GET_HAS_MERCHANT_TRANSACTED_SUCCESS,
    actionTypeFailure: ActionConstants.GET_HAS_MERCHANT_TRANSACTED_FAILURE,
    actionTypeRequest: ActionConstants.GET_HAS_MERCHANT_TRANSACTED_REQUEST,
    hideLoader: true,
  };
  return { type: ActionConstants.GET_HAS_MERCHANT_TRANSACTED, payload };
};

// apple pay actions

export const getDownloadCsrApplePayAction = (data) => {
  const payload = {
    serviceMethod: getCsrApplePayApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_DOWNLOAD_CSR_APPLE_PAY_SUCCESS,
    actionTypeFailure: ActionConstants.GET_DOWNLOAD_CSR_APPLE_PAY_FAILURE,
    actionTypeRequest: ActionConstants.GET_DOWNLOAD_CSR_APPLE_PAY_REQUEST,
  };
  return { type: ActionConstants.GET_DOWNLOAD_CSR_APPLE_PAY, payload };
};

export const clearGetDownloadCsrApplePayAction = () => {
  return { type: ActionConstants.GET_DOWNLOAD_CSR_APPLE_PAY_CLEAR };
};


export const getApplePayWalletStatusAction = (options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(options || {}) },
      ActionConstants.GET_APPLE_PAY_WALLET_STATUS
    );
  const payload = {
    serviceMethod: getApplePayWalletStatusApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_APPLE_PAY_WALLET_STATUS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_APPLE_PAY_WALLET_STATUS_FAILURE,    
    actionTypeRequest: ActionConstants.GET_APPLE_PAY_WALLET_STATUS_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_APPLE_PAY_WALLET_STATUS, payload };
};
export const clearGetApplePayWalletStatusAction = () => {
  return { type: ActionConstants.GET_APPLE_PAY_WALLET_STATUS_CLEAR };
};


export const getApplePayIntegrationStatusAction = (options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { ...(options || {}) },
      ActionConstants.GET_APPLE_PAY_INTEGRATION_STATUS
    );
  const payload = {
    serviceMethod: getApplePayIntegrationStatusApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_APPLE_PAY_INTEGRATION_STATUS_SUCCESS,
    actionTypeFailure: ActionConstants.GET_APPLE_PAY_INTEGRATION_STATUS_FAILURE,
    actionTypeRequest: ActionConstants.GET_APPLE_PAY_INTEGRATION_STATUS_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_APPLE_PAY_INTEGRATION_STATUS, payload };
};
export const clearGetApplePayIntegrationStatusAction = () => {
  return { type: ActionConstants.GET_APPLE_PAY_INTEGRATION_STATUS_CLEAR };
};



// web registration action
export const webRegistrationApplePayAction = (data) => {
  const payload = {
    serviceMethod: webRegistrationApplePayApi.bind(null, data),
    actionTypeSuccess: ActionConstants.WEB_REGISTRATION_APPLE_PAY_SUCCESS,
    actionTypeFailure: ActionConstants.WEB_REGISTRATION_APPLE_PAY_FAILURE,
    actionTypeRequest: ActionConstants.WEB_REGISTRATION_APPLE_PAY_REQUEST,
  };
  return { type: ActionConstants.WEB_REGISTRATION_APPLE_PAY, payload };
};
export const clearWebRegistrationApplePayAction = () => {
  return { type: ActionConstants.WEB_REGISTRATION_APPLE_PAY_CLEAR };
};


// apple pay certificate activate action

export const activateApplePayCertificateAction = (data) => {
  const payload = {
    serviceMethod: activateApplePayCertificatesApi.bind(null, data),
    actionTypeSuccess: ActionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE_SUCCESS,
    actionTypeFailure: ActionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE_FAILURE,
    actionTypeRequest: ActionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE_REQUEST, 
  };
  return { type: ActionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE, payload };
};
export const clearActivateApplePayCertificateAction = () => {
  return { type: ActionConstants.ACTIVATE_APPLE_PAY_CERTIFICATE_CLEAR };
};

export const getDashboardThemeAction = (data: {
  merchantId: MerchantIdType;
}) => {
  const payload = {
    serviceMethod: getDashboardThemeApi.bind(null, data),
    actionTypeSuccess: ActionConstants.GET_DASHBOARD_THEME_SUCCESS,
    actionTypeFailure: ActionConstants.GET_DASHBOARD_THEME_FAILURE,
    actionTypeRequest: ActionConstants.GET_DASHBOARD_THEME_REQUEST,
  };
  return { type: ActionConstants.GET_DASHBOARD_THEME, payload };
};

export const clearGetDashboardThemeAction = () => {
  return { type: ActionConstants.GET_DASHBOARD_THEME_CLEAR };
};

export const updateDashboardThemeAction = (data) => {
  const payload = {
    serviceMethod: updateDashboardThemeApi.bind(null, data),
    actionTypeSuccess: ActionConstants.POST_UPDATE_DASHBOARD_THEME_SUCCESS,
    actionTypeFailure: ActionConstants.POST_UPDATE_DASHBOARD_THEME_FAILURE,
    actionTypeRequest: ActionConstants.POST_UPDATE_DASHBOARD_THEME_REQUEST,
  };
  return { type: ActionConstants.POST_UPDATE_DASHBOARD_THEME, payload };
};

export const clearUpdateDashboardThemeAction = () => {
  return { type: ActionConstants.POST_UPDATE_DASHBOARD_THEME_CLEAR };
};

export const getPaymentModesAction = (emailId, options?: LoaderOptions) => {
  const { requestData, hideLoader, loaderMessage, cancelKey, requestId } =
    getCancelableRequestMeta(
      { emailId, ...(options || {}) },
      ActionConstants.GET_PAYMENT_MODES
    );
  const payload = {
    serviceMethod: getPaymentModesApi.bind(null, requestData),
    actionTypeSuccess: ActionConstants.GET_PAYMENT_MODES_SUCCESS,
    actionTypeFailure: ActionConstants.GET_PAYMENT_MODES_FAILURE,
    actionTypeRequest: ActionConstants.GET_PAYMENT_MODES_REQUEST,
    hideLoader,
    loaderMessage,
    cancelKey,
    extra: { requestId },
  };
  return { type: ActionConstants.GET_PAYMENT_MODES, payload };
};

export const clearGetPaymentModesAction = () => {
  return { type: ActionConstants.GET_PAYMENT_MODES_CLEAR };
};
